import { Storage } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';

export const MediaContainer = styled.div`
    flex: 1;
    flex-direction: row;
    gap: 1rem;
    align-items: stretch;
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
`

const Image = styled.img`
    max-width: 30%;
    max-height: 25%;
    object-fit: cover;
    cursor: pointer;

    @media(max-width: 768px) {
        max-width: 100%;
        max-height: 500px;
    }
    `

const Video = styled.video`
    max-width: 30%;
    max-height: 25%;
    cursor: pointer;
    
    @media(max-width: 768px) {
        max-width: 100%;
        max-height: 500px;
    }
`

export default ({ media }) => {
    const [url, setUrl] = useState();
    useEffect(() => {
        (async () => {
            try {
                const resp = await Storage.get(media.filename);
                setUrl(resp);
            } catch (ex) {
                console.log(ex.message);
            }
        })();
    }, [media.filename])

    switch (media.mediaType) {
        case 'IMAGE':
            return <Image src={url} onClick={() => window.open(url, "_blank")} />
        case 'VIDEO':
            return <Video src={url} onClick={() => window.open(url, "_blank")} autoPlay muted />
    }
}